import $ from 'jquery';
import React from 'react';
import UserToken,{checkUserSession} from '../function_lib/userToken';
import {AjaxCallMethod,getAccessRolesNew,RespBkMthdMapp,_getInitParam,defaultLogo
,CallMapMethod_CBack} from '../function_lib/common_lib';
//import {CallCMSMapMethod,AjaxCallMethodCMS} from '../function_lib/common_cms';
import {Add_Network_Comp} from '../components/add_network_comp';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { Player } from 'video-react';

import GooglePlay from '../assets/images/google-play.jpg';
import AppStore from '../assets/images/mac.jpg';
import './index.css';
import './login_v2.css';


let loginUser="";
let userObject="";
let _indInitObject={};
let LogoImg;
let clsIndexLogin;
class Member_Login extends React.Component{
  constructor(props){
    super(props);
    _indInitObject=_getInitParam();
    checkUserSession(false);//for limittime
    if(localStorage.getItem("userData")!=null){
      UserToken.setUserObject(localStorage.getItem("userData"));
      userObject= UserToken.getUserObject();
      loginUser=userObject[0].person_name;
      window.location.href="./Dashboard";
    }
    LogoImg=defaultLogo();
    clsIndexLogin=this;
  }
  checkNetwork(){
    let map=[];
        map.push({name:"curl_type",value:"getNetworkd"});
        map.push({name:"res_func",value:"callBackrrr"});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getNetworkd";
        CallMapMethod_CBack(this,map,function(data,msg){
          //alert(data);
          let lsNetW=JSON.parse(data);
          if(lsNetW.length===0){
            $("#divNetWorkComp").modal('show');
          }

        })
  }
  veriFyMemberOtp(){
    let map=[];
    map.push({name:"curl_type",value:"loginVerification"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"vfkey",value:$("#member_otp_lgvfkey").val()});
    map.push({name:"input_otp",value:$("#member_otp_lg_inp").val()});

    // map.push({name:"p2",value:$("#p2").val()});
    map["res_func"]="callBackrrr";
    map["curl_type"]="loginVerification";
    CallMapMethod_CBack(clsIndexLogin,map,function(data,msg){
      if(data!=="0" && data!==""){
        //alert(data);
        let jsData=JSON.parse(data);
        //alert(jsData.user_info.length);
        if(jsData.user_info.length===1){
          let datat={};
          datat["user"]=[{"id":jsData.user_info[0]["id"],
            "app_user_id":jsData.user_info[0]["id"],
            "company_name":jsData.user_info[0]["entity_name"],
            "first_name":jsData.user_info[0]["person_name"],
            "last_name":"",
            "type":"1",
            "access_type":jsData.user_info[0]["access_type"],
          }];
          //alert(jsData.user_info[0]["authority"]);
          //datat["role"]=[{"col1":"user,master"},{"col2":btoa(jsData.user_info[0]["access_location"])}];
            datat["role"]=[{"col1":btoa(jsData.user_info[0]["authority"])},{"col2":btoa(jsData.user_info[0]["access_modules"])}];
          
          clsIndexLogin.okSucc(JSON.stringify(datat),"success");
        }else{
          clsIndexLogin.okSucc("0","");
        }
      }
    })


  }
  viaMemberLoginId(){

    
    let user_captcha = document.getElementById('user_captcha').value;
// captcha validation
    if (validateCaptcha(user_captcha)===true) {
    let map=[];
    map.push({name:"curl_type",value:"getMemberFLogin"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"p1_member_id",value:$("#p1_member_id").val()});
    // map.push({name:"p2",value:$("#p2").val()});
    map["res_func"]="callBackrrr";
    map["curl_type"]="getMemberFLogin";
    CallMapMethod_CBack(clsIndexLogin,map,function(data,msg){
      //alert(data);
      //return;
      if(data==="001"){
        let jsMsg=JSON.parse(msg);
        $("#member_otp_lg_respmsg").text(jsMsg["msg"]);
        $("#member_otp_lgvfkey").val(jsMsg["vfkey"]);
        clsIndexLogin.setClickFor("member_otp_lg_inp");
      }
      
      if(data!=="0" && data!==""){
        //alert(data);
        //let jsData=JSON.parse(data);
        //alert(jsData.user_info.length);
       
      }
      
    })
  }else{
    clsIndexLogin.okSucc("0","Invalid Code");
  }



  }

  checkLogin(){
    
    let map=[];
    map.push({name:"curl_type",value:"getMemberFLogin"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"p1",value:$("#p1").val()});
    map.push({name:"p2",value:$("#p2").val()});
    map["res_func"]="callBackrrr";
    map["curl_type"]="getMemberFLogin";
    CallMapMethod_CBack(clsIndexLogin,map,function(data,msg){
      //alert(data);
      if(data!=="0" && data!==""){
        //alert(data);
        let jsData=JSON.parse(data);
        //alert(jsData.user_info.length);
        if(jsData.user_info.length===1){
          //alert(JSON.stringify(jsData.user_info[0]));
          let datat={};
          datat["user"]=[{"id":jsData.user_info[0]["id"],
            "app_user_id":jsData.user_info[0]["id"],
            "first_name":jsData.user_info[0]["entity_name"],
            "last_name":jsData.user_info[0]["mem_no"],
            "type":"1",
            "access_type":jsData.user_info[0]["access_type"]
          }];
          //alert(jsData.user_info[0]["authority"]);
          //datat["role"]=[{"col1":"user,master"},{"col2":btoa(jsData.user_info[0]["access_location"])}];
            datat["role"]=[{"col1":btoa(jsData.user_info[0]["authority"])},{"col2":btoa(jsData.user_info[0]["access_location"])}];
          //alert(JSON.stringify(datat));
          clsIndexLogin.okSucc(JSON.stringify(datat),"success");
        }else{
          clsIndexLogin.okSucc("0","");
        }
      }
      
    })
}



  okSucc(data,datares){
    //alert(data+datares);
   // return;
   if(data===-10){
    return;
   }
    if(data!="0" && data!=""){
      $("#getReponse").html("Login Successfully..");
     checkUserSession(true);
     localStorage.setItem('userData',data);
     
     window.location.href="./dashboard";
     
     
    }else{
      $(".respSSL").html("Invalid UserName or Password !");
    }

}

okFirstSetupResp(data,msg){
alert(data+msg)
}
componentDidMount(){
  loadCaptchaEnginge(4,'white','black','lower');
  AjaxCallMethod(this,"okSuccCNOT");
  this.checkNetwork();
  //RespBkMthdMapp(this,"","keyEvent");
}

setClickFor(idName){
  if(idName=="member_otp_lg_inp"){
    
    document.getElementById("member_lg").classList.remove("active");
    
    document.getElementById("lg5").classList.remove("active");
    
    document.getElementById("member_otp_lg").classList.add("active");
  }else if(idName==="nav_otp"){
    //alert("i m in nav_otp");
    document.getElementById("nav_login").classList.remove("active");
    //document.getElementById("nav_regsi").classList.add("active");

    //document.getElementById("lg2").classList.remove("active");
    document.getElementById("lg1").classList.remove("active");
    document.getElementById("lg4").classList.remove("active");
    document.getElementById("lg5").classList.remove("active");

    document.getElementById("lg3").classList.add("active");
  }else if(idName==="nav_regsi"){
      document.getElementById("nav_login").classList.remove("active");
      //document.getElementById("nav_regsi").classList.add("active");
      //document.getElementById("lg2").classList.add("active");
      document.getElementById("lg1").classList.remove("active");
      document.getElementById("lg3").classList.remove("active");
      document.getElementById("lg4").classList.remove("active");
      document.getElementById("lg5").classList.remove("active");
      }else if(idName==="nav_setpassword"){
      document.getElementById("lg5").classList.add("active");
      //document.getElementById("nav_regsi").classList.remove("active");
      //document.getElementById("lg2").classList.remove("active");
      document.getElementById("lg1").classList.remove("active");
      document.getElementById("lg3").classList.remove("active");
      document.getElementById("lg4").classList.remove("active");
      document.getElementById("nav_login").classList.remove("active");
      }
      else{
        //alert("i am in back to login");
      document.getElementById("nav_login").classList.add("active");
      //document.getElementById("nav_regsi").classList.remove("active");
      //document.getElementById("lg2").classList.remove("active");
      document.getElementById("lg1").classList.add("active");
      document.getElementById("lg3").classList.remove("active");
      document.getElementById("lg4").classList.remove("active");
      document.getElementById("lg5").classList.remove("active");
    }
  
  //$("#nav_regsi").click();
}
    render(){
        return(<div class="login-form-v2">
          <div class="container">
              <div class="row g-0  rounded">
                  {/* <!-- Image Section --> */}
                  <div class="col-md-6 d-none d-md-block  cover-lefft-side">
                      {/* <img src="https://onetreeplanted.org/cdn/shop/articles/nature_facts_1600x.jpg?v=1705008496"/> */}
                      {/* <img src={_indInitObject["logoPath"].trim()!==""?_indInitObject["logoPath"]:LogoImg} style={{"width":"100%"}} className="img-fluid" /> */}
                  </div>
                  {/* <!-- Form Section --> */}
                  <div class="col-md-6 d-flex align-items-center">
                  
                      <div class="w-100 loginForm-log-v2">
                      <img src={_indInitObject["logoPath"].trim()!==""?_indInitObject["logoPath"]:LogoImg} style={{"width":"100%"}} className="img-fluid d-mobile" />
                         <hr class="d-mobile"/>
                         {/* step memberId */}
<div className="fdiv tab-content">
<div id="member_lg" className="tab-pane active">
<form id="frmLogin" name="frmLogin" action="#">
                          <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                    <input type="hidden" name="curl_type" id="curl_type" value="logint" />
                    <input type="hidden" name="m_type" id="m_type" value="logint" />
                    {/* <div className="form-group">
                             
                              <input type="text" className="form-control" id="txtCompanyCode" name="txtCompanyCode" placeholder="Company Code.." />
                            </div> */}
                            <div className="form-group">
                              <input type="text" className="form-control required" id="p1_member_id" name="p1_member_id" placeholder="CDC No." />
                            </div>
                            <div className="form-group">
                            <LoadCanvasTemplate />
                            <input id="user_captcha" name="user_captcha" type="text" class="form-control required" />

                            </div>
                            <div class="col-12 respSSL"></div>
                            <div className="form-group">
                  <button type="button" id="btnLogin" name="btnLogin" 
                  onClick={()=>this.viaMemberLoginId()}
                  // onClick={()=>this.setClickFor("nav_contactotp")} 
                  className="btn _btnSetColor123 btn-sm float-left btn-success">Login</button>   <a className="font-small float-right float-right text-cyan" href="" >Forgot CDC No. ?</a>
                            </div>
                            </form>
</div>
{/* end of member_lg */}

<div id="member_otp_lg" className="tab-pane">
<form id="frmMemberOtpLg" name="frmMemberOtpLg" action="#">
                          <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                    <input type="hidden" name="curl_type" id="curl_type" value="logint" />
                    <input type="hidden" name="m_type" id="m_type" value="logint" />
                    <input type="hidden" name="member_otp_lgvfkey" id="member_otp_lgvfkey" />
                     <div className="form-group">
                      <center> <b>* Do not refresh or reload the application</b> <br/>
                     
                             <a href="javascript:void(0)"><span id="member_otp_lg_respmsg"></span></a>
                             </center>
                            </div> 
                            <div className="form-group">
                              <input type="text" className="form-control required" id="member_otp_lg_inp" name="member_otp_lg_inp" placeholder="Enter 4 digit OTP" />
                            </div>
                           
                            <div class="col-12 respSSL"></div>
                            <div className="form-group">
                  <button type="button" id="btnLogin" name="btnLogin" 
                  onClick={()=>this.veriFyMemberOtp()}
                  // onClick={()=>this.setClickFor("nav_contactotp")} 
                  className="btn _btnSetColor123 btn-sm float-left btn-success">Submit</button>   <a className="font-small float-right float-right text-cyan" href="" >Forgot Password ?</a>
                            </div>
                            </form>
</div>

<div id="lg4" className="tab-pane">
  "i m in lg4"
</div>

<div id="lg5" className="tab-pane">
  "i m in lg5"
</div>

</div>
{/* end of step memberId */}
                        
                          
                      </div>
                  </div>
              </div>
          </div>
          <Add_Network_Comp  />
          </div>);
    }
}
export default Member_Login